import { checkDATConditions } from '../utils';

/**
 * Tính dải chỉ tiêu DAT cho một bảng phiên học, và ra phán quyết đạt/chưa đạt.
 *
 * Tách nguyên văn ra khỏi `useEffect` trong `AdminPageV2.jsx` để test được —
 * KHÔNG sửa một phép tính nào. Mọi chỗ trông như lỗi ở đây đều là hành vi đang
 * chạy trên production và đang quyết định số của học viên thật; xem
 * `tinhChiTieuDat.test.js` để biết chỗ nào đã được chốt có chủ ý.
 *
 * Trả về đúng vật mà trang đang đưa vào `setResult`: tám tổng cộng dồn, cộng
 * với kết quả của `checkDATConditions` trải phẳng vào cùng một object
 * (`valid` + `details`, hoặc `valid` + `message` khi không tra được hạng).
 *
 * @param {Array<object>} rowData danh sách phiên học đang hiển thị
 */
export function tinhChiTieuDat(rowData = []) {
  const sum = (fn) => rowData.reduce((acc, cur) => acc + (!cur.violation?.length ? (fn(cur) || 0) : 0), 0);
  const totalDuration = sum((c) => c.duration);
  const totalDistance = sum((c) => c.distance);
  const totalDurationDungHang = sum((c) => c.durationSameHang);
  const totalDistanceDungHang = sum((c) => c.distanceSameHang);
  const totalNightDurationDungHang = rowData.reduce((acc, cur) => {
    let val = 0;
    const ck = cur.courseShortName;
    const pick = cur.nightDuration ? cur.nightDuration : (cur.manualNightDuration ? cur.manualNightDuration : 0);
    if (ck?.includes('B1') || ck?.includes('BTĐ')) {
      val = ['B1', 'B.01', 'B11'].includes(cur.vehicleHang) ? pick : 0;
    } else if (ck?.includes('B2') || ck?.includes('BSS')) {
      val = ['B2', 'B'].includes(cur.vehicleHang) ? pick : 0;
    } else if (ck?.includes('C1')) {
      val = ['C1', 'C'].includes(cur.vehicleHang) ? pick : 0;
    }
    return acc + (!cur.violation?.length ? parseFloat(val) : 0);
  }, 0);
  const totalAutoDuration = sum((c) => c.autoDuration);
  const totalAutoDistance = sum((c) => c.autoDistance);
  const manualNightDuration = rowData.reduce(
    (acc, cur) => acc + (!cur.violation?.length && cur.manualNightDuration ? parseFloat(cur.manualNightDuration) : 0),
    0,
  );
  const res = checkDATConditions(
    rowData[0]?.courseShortName?.split('-')?.[0],
    totalDuration,
    totalDistance,
    totalDurationDungHang,
    totalNightDurationDungHang,
    totalAutoDuration,
  );
  return {
    totalDuration,
    totalDistance,
    totalDurationDungHang,
    totalDistanceDungHang,
    totalNightDurationDungHang,
    totalAutoDuration,
    totalAutoDistance,
    manualNightDuration,
    ...res,
  };
}
